module.exports = __webpack_public_path__ + "static/support-2f768e3c2c68eadffe0c094029219191.svg";